module.exports = __webpack_public_path__ + "img/shape1.d43f8ec5.png";